import { useTranslation } from "react-i18next";
import { Dialog, DialogTitle, DialogContent } from "@material-ui/core";
import { Typography, Button, Paper, DialogActions } from "@material-ui/core";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";

// Components
import MaturityBanner from "./MaturityBanner";

// Styles
import AssessmentResultPopoverStyle from "../../../../assets/styles/materialUI/questionnaire/assessmentResult/assessmentDashboard/AssessmentResultPopoverStyle";

// Providers
import { useLanguage } from "../../../../contexts/languageContext";

export default function AssessmentResultPopover({
	selectedAssessment,
	submissionData,
	viewDialog,
	handleCloseDialogs,
}) {
	const { t } = useTranslation();
	const { direction } = useLanguage();
	const classes = AssessmentResultPopoverStyle();

	const calculateMaturityKey = (data) => {
		const score = (data.score / data.total_score) * 10;

		if (score >= 0 && score <= 2) {
			return "notStarted";
		} else if (score > 2 && score <= 4) {
			return "developing";
		} else if (score > 4 && score <= 6) {
			return "established";
		} else if (score > 6 && score <= 8) {
			return "integrated";
		} else if (score > 8 && score <= 10) {
			return "advanced";
		} else {
			return "na";
		}
	};

	return (
		<Dialog open={viewDialog} onClose={handleCloseDialogs} maxWidth="md" fullWidth dir={direction}>
			<DialogTitle className={classes.dialogTitle}>
				{t("assessment.results.popover.title", { date: selectedAssessment?.date })}
			</DialogTitle>
			<DialogContent dividers>
				{submissionData?.categories?.length > 0 ? (
					<TableContainer component={Paper} className={classes.tableContainer}>
						<Table stickyHeader>
							<TableHead className={classes.tableHead}>
								<TableRow>
									<TableCell className={classes.tableHeadCell}>
										{t("assessment.results.popover.area")}
									</TableCell>
									<TableCell className={classes.tableHeadCell}>
										{t("assessment.results.popover.score")}
									</TableCell>
									<TableCell className={classes.tableHeadCell}>
										{t("assessment.results.popover.level")}
									</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{submissionData?.categories?.map((row, index) => (
									<TableRow
										key={index}
										className={index % 2 === 0 ? classes.tableRowEven : classes.tableRowOdd}
									>
										<TableCell className={classes.categoryTableCell}>
											{index + 1}. {direction === "ltr" ? row.category : row.category_ar}
										</TableCell>
										<TableCell className={classes.resultTableCell}>
											<Typography className={classes.scoreText}>
												{((row.score / row.total_score) * 10).toFixed(1)}
											</Typography>
										</TableCell>
										<TableCell className={classes.resultTableCell}>
											<Typography variant="body2" className={classes.levelText}>
												{(() => {
													const maturityKey = calculateMaturityKey(row);
													return (
														<>
															<MaturityBanner score={maturityKey} />{" "}
															{t(`maturity.levels.${maturityKey}`)}
														</>
													);
												})()}
											</Typography>
										</TableCell>
									</TableRow>
								))}
							</TableBody>
						</Table>
					</TableContainer>
				) : (
					<Typography variant="body2" color="textSecondary">
						{t("assessment.results.popover.noData")}
					</Typography>
				)}
			</DialogContent>
			<DialogActions>
				<Button onClick={handleCloseDialogs} className={classes.Button} variant="contained" color="primary">
					{t("common.buttons.close")}
				</Button>
			</DialogActions>
		</Dialog>
	);
}
